module.exports = __webpack_public_path__ + "src/img/zalando/img-laptops-sketch.59ce6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/img-laptops-sketch.jpg
// module id = 126
// module chunks = 0